export const CONNECTIONS_CRUD_FEATURE = "connections_partner_crud";

export interface ConnectionsAccessUser {
  features?: {
    connections_partner_crud?: boolean;
  };
}

export const canAccessConnectionsCrud = (
  user: ConnectionsAccessUser | null | undefined,
): boolean => user?.features?.[CONNECTIONS_CRUD_FEATURE] === true;
